import { Identified } from "@/types/sdk-types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientControllerApi, Patient } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

export interface UseSearchPatientListProps {
  pagination: DGT_Pagination;
  searchString?: string;
  xTENANTID?: string;
  isReferral?: boolean;
  disabled?: boolean;
}

/**
 *
 * @author [Rajkumar Rathod]
 */

export function useSearchPatientList({
  pagination,
  searchString,
  xTENANTID,
  isReferral,
  disabled = false,
}: UseSearchPatientListProps): useBaseContent<Identified<Patient>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  return useQuery({
    queryKey: [
      "search-patient-list",
      pageSize,
      pageIndex,
      xTENANTID,
      searchString,
      isReferral,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: !disabled,
    queryFn: async () =>
      new PatientControllerApi(getConfigObject())
        .getPatientList(
          pageIndex, //page
          pageSize, //size
          undefined, //sortBy
          undefined, //sortDirection
          undefined, //status
          false, //archive
          isReferral ?? false, //isReferral ,
          searchString, //searchString
          xTENANTID! //xTENANTID
        )
        .then((res) => res?.data),
  });
}
